<script>
  import { fade } from 'svelte/transition';
  import {
    ChevronLeftOutline,
    ChevronRightOutline,
  } from 'flowbite-svelte-icons';
  import { _ } from 'svelte-i18n';

  let activeSlide = 0;

  function changeSlide(newSlide) {
    if (newSlide < 0) {
      activeSlide = 3;
    } else {
      activeSlide = newSlide % 4;
    }
  }
</script>

<div class="my-2 w-full">
  <div class="relative h-[16rem] w-full rounded-lg bg-[#f4f2ff]">
    <div class="absolute bottom-2 left-1/2 z-10 flex -translate-x-1/2 gap-2">
      <div class="flex items-center gap-2">
        {#if activeSlide !== 0}
          <div class="flex items-center rounded-full bg-black p-1">
            <button
              class="text-white"
              on:click={() => changeSlide(activeSlide - 1)}
            >
              <ChevronLeftOutline size="xs" />
            </button>
          </div>
        {/if}
        {#each [0, 1, 2, 3] as slide}
          {#if slide === activeSlide}
            <button
              on:click={() => changeSlide(slide)}
              class="h-2 w-2 rounded-full border border-black bg-black"
            ></button>
          {:else}
            <button
              on:click={() => changeSlide(slide)}
              class="h-2 w-2 rounded-full border border-black bg-white"
            ></button>
          {/if}
        {/each}
        {#if activeSlide !== 3}
          <div
            class="flex items-center justify-center rounded-full bg-black p-1"
          >
            <button
              class="text-white"
              on:click={() => changeSlide(activeSlide + 1)}
            >
              <ChevronRightOutline size="xs" />
            </button>
          </div>
        {/if}
      </div>
    </div>
    {#if activeSlide === 0}
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="flex justify-between p-4 lg:p-11"
      >
        <div class="w-full max-w-[34rem] lg:w-3/5">
          <p
            class="mb-2 w-fit rounded-md bg-[#977dff] px-2 py-1 text-sm capitalize tracking-wide text-white"
          >
            {$_('curatedby.carousel.card1.title', {
              default: 'Exclusive Early Access',
            })}
          </p>
          <h2 class="mb-4 text-xl font-bold">
            {$_('curatedby.carousel.card1.subtitle', {
              default: 'Welcome to CuratedBy',
            })}
          </h2>
          <p>
            {$_('curatedby.carousel.card1.text1', {
              default:
                'You’re part of an exclusive group receiving early access to a new feature that automatically connects your audience with your favorite products - ',
            })}
            <span class="font-bold">
              {$_('curatedby.carousel.card1.text2', {
                default: 'all in one link.',
              })}
            </span>
          </p>
        </div>
        <div class="relative right-12 hidden lg:block">
          <div class="absolute -left-16 top-4 rotate-2">
            <img src="/images/sparkles.svg" class="text-[#977DFF]" />
          </div>
          <div class="absolute -right-16 bottom-0 -rotate-2">
            <img src="/images/sparkles.svg" class="text-[#977DFF]" />
          </div>
          <img
            class="max-w-[11rem] rotate-6 drop-shadow-[0_16px_16px_rgba(0,0,0,0.25)]"
            src="/images/cb-logo.png"
          />
        </div>
      </div>
    {:else if activeSlide === 1}
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute hidden h-full w-full xl:block"
      >
        <div class="absolute right-[28rem] top-1/4 hidden rotate-2 lg:block">
          <img src="/images/sparkles.svg" class="text-[#977DFF]" />
        </div>
        <div class="absolute bottom-4 right-8 hidden -rotate-2 lg:block">
          <img src="/images/sparkles.svg" class="text-[#977DFF]" />
        </div>
      </div>
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute right-0 top-0 hidden h-full rounded-tr-lg xl:block"
      >
        <img src="/images/bg-wave.svg" class="h-full w-auto rounded-tr-lg" />
      </div>
      <picture
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute bottom-0 right-[100px] hidden h-[14rem] w-[19rem] overflow-hidden rounded-t-lg object-top xl:block"
      >
        <img
          src="/images/cb-carousel-preview.png"
          class="absolute left-0 top-0 h-[25rem] object-cover object-top"
        />
      </picture>
      <div in:fade={{ delay: 500 }} out:fade class="p-4 lg:p-11">
        <div class="w-full xl:w-3/5 xl:max-w-[45ch]">
          <p
            class="mb-2 w-fit rounded-md bg-[#977dff] px-2 py-1 text-sm capitalize tracking-wide text-white"
          >
            {$_('curatedby.carousel.card2.title', {
              default: 'Exclusive Early Access',
            })}
          </p>
          <h2 class="mb-4 text-xl font-bold">
            {$_('curatedby.carousel.card2.subtitle', {
              default: 'What is CuratedBy',
            })}
          </h2>
          <p>
            {$_('curatedby.carousel.card2.text1', {
              default: 'CuratedBy is a custom, standalone page that',
            })}
            <span class="font-bold">
              {$_('curatedby.carousel.card2.text2', {
                default: 'dynamically refreshes in real time',
              })}
            </span>
            {$_('curatedby.carousel.card2.text3', {
              default: 'to help your followers find both',
            })}
            <span
              class="rounded-full bg-[#997dff] px-[.5rem] py-[.1rem] font-bold text-white"
            >
              {$_('curatedby.carousel.card2.text4', {
                default: '1',
              })}
            </span>
            {$_('curatedby.carousel.card2.text5', {
              default: 'new links you’ve recently started sharing and',
            })}
            <span
              class="rounded-full bg-[#997dff] px-2 py-[.1rem] font-bold text-white"
            >
              {$_('curatedby.carousel.card2.text6', {
                default: '2',
              })}
            </span>
            {$_('curatedby.carousel.card2.text7', {
              default: 'your most popular links from the last 30 days.',
            })}
          </p>
        </div>
      </div>
    {:else if activeSlide === 2}
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute hidden h-full w-full xl:block"
      >
        <div class="absolute right-[24rem] top-1/4 rotate-3">
          <img src="/images/sparkles.svg" class="text-[#977DFF]" />
        </div>
        <div class="-rotate-4 absolute bottom-4 right-16">
          <img src="/images/sparkles.svg" class="text-[#977DFF]" />
        </div>
      </div>
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute right-0 top-0 hidden h-full rounded-tr-lg xl:block"
      >
        <img src="/images/bg-wave.svg" class="h-full w-auto rounded-tr-lg" />
      </div>
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="flex justify-between p-4 lg:p-11"
      >
        <div class="w-full lg:max-w-[60ch] xl:w-3/5">
          <p
            class="mb-2 w-fit rounded-md bg-[#977dff] px-2 py-1 text-sm capitalize tracking-wide text-white"
          >
            {$_('curatedby.carousel.card3.title', {
              default: 'Exclusive Early Access',
            })}
          </p>
          <h2 class="mb-4 text-xl font-bold">
            {$_('curatedby.carousel.card3.subtitle', {
              default: 'Extra Rewards without the Extra Work',
            })}
          </h2>
          <p>
            <span class="font-bold">
              {$_('curatedby.carousel.card3.text1', {
                default: 'A URL that you share once and forget about',
              })}
            </span>
            {$_('curatedby.carousel.card3.text2', {
              default:
                '- we’ll take it from there to constantly keep it updated for any new link you create in PostTap.',
            })}
          </p>
        </div>
        <div
          in:fade={{ delay: 500 }}
          out:fade
          class="relative hidden h-full w-full xl:block"
        >
          <img
            src="/images/products-collage.png"
            class="absolute -top-4 right-24 z-10 h-52 w-auto"
          />
        </div>
      </div>
    {:else if activeSlide === 3}
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute hidden h-full w-full xl:block"
      >
        <div class="absolute right-[28rem] top-1/4 rotate-2">
          <img src="/images/sparkles.svg" class="text-[#977DFF]" />
        </div>
        <div class="absolute bottom-4 right-6 -rotate-2">
          <img src="/images/sparkles.svg" class="text-[#977DFF]" />
        </div>
      </div>
      <div
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute right-0 top-0 hidden h-full rounded-tr-lg xl:block"
      >
        <img src="/images/bg-wave.svg" class="h-full w-auto rounded-tr-lg" />
      </div>
      <picture
        in:fade={{ delay: 500 }}
        out:fade
        class="absolute bottom-0 right-[78px] block hidden h-[14rem] w-[19rem] overflow-hidden rounded-t-lg object-top xl:block"
      >
        <img
          src="/images/cb-insta-preview.png"
          class="absolute left-0 top-0 h-[25rem] w-[19rem] object-cover object-top"
        />
      </picture>
      <div in:fade={{ delay: 500 }} out:fade class="p-4 xl:p-11">
        <div class="w-full xl:w-3/5 xl:max-w-[45ch]">
          <p
            class="mb-2 w-fit rounded-md bg-[#977dff] px-2 py-1 text-sm capitalize tracking-wide text-white"
          >
            {$_('curatedby.carousel.card4.title', {
              default: 'Exclusive Early Access',
            })}
          </p>
          <h2 class="mb-4 text-xl font-bold">
            {$_('curatedby.carousel.card4.subtitle', {
              default: 'Add to Your Socials',
            })}
          </h2>
          <p>
            {$_('curatedby.carousel.card4.text1', {
              default:
                'Once you create your CuratedBy link - share it anywhere! We think it fits nicely within your Instagram bio - but ',
            })}
            <span class="font-bold">
              {$_('curatedby.carousel.card4.text2', {
                default:
                  'use it anywhere you want your followers to easily find',
              })}
            </span>
            {$_('curatedby.carousel.card4.text3', {
              default: 'any of your top or recent Amazon links.',
            })}
          </p>
        </div>
      </div>
    {/if}
  </div>
</div>
